import { render, staticRenderFns } from "./PackageClass.vue?vue&type=template&id=9ca0ed6e&scoped=true&"
import script from "./PackageClass.vue?vue&type=script&lang=js&"
export * from "./PackageClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca0ed6e",
  null
  
)

export default component.exports